// extracted by mini-css-extract-plugin
module.exports = {"container":"SimilarJobs_container__Drmfp","title":"SimilarJobs_title__FjXj4"};